module.exports={
	"googleMapsApiKey": "AIzaSyAws1Yzpw_ZeH1x5DDFm_cKw6c4-227NlE"
}